// src/plugins/data_graph.js
import VueChartkick from 'vue-chartkick';
import Chartkick from 'chartkick';
import Chart from 'chart.js/auto';

// Passe Chart.js à Chartkick
Chartkick.use(Chart);

// Exporter un plugin personnalisé qui configure correctement Chartkick
export default {
  install(app) {
    // Utiliser VueChartkick avec l'app
    VueChartkick.install(app, { Chartkick });
  }
};
